import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useStateContext } from "../../../context/StateContext_KO";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import {
  doc,
  setDoc,
  db,
  getDoc,
  serverTimestamp,
  addDoc,
  collection,
} from "../../../firebase";

import Fade from "react-reveal/Fade";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FeaturedProductRecent from "./FeaturedProductsBestSellers";
import emailjs from "@emailjs/browser";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Success = () => {
  const { t, i18n } = useTranslation();
  const [orderId, setOrderId] = useState(null);
  let navigate = useNavigate();

  let query = useQuery();
  const { currentUser } = useAuth();
  const { basket, taxPrice, emptyBasket } = useStateContext();
  const [err, setErr] = useState(null);
  const [orderBasket, setOrderBasket] = useState([]);

  console.log("guestPassword &&&&", sessionStorage.getItem("guestPassword"));
  console.log("Phone &&&&", sessionStorage.getItem("phone"));
  console.log(
    sessionStorage.getItem("checkout_email"),
    sessionStorage.getItem("checkout_tax_rate"),
    sessionStorage.getItem("basket"),
    sessionStorage.getItem("checkout_taxprice"),
    sessionStorage.getItem("checkout_shippingOption"),
    sessionStorage.getItem("checkout_shippingPrice"),
    sessionStorage.getItem("checkout_total"),
    sessionStorage.getItem("checkout_subtotal"),
    sessionStorage.getItem("checkout_userUID"),
    sessionStorage.getItem("paymentOption"),
    sessionStorage.getItem("bank"),
    sessionStorage.getItem("customer_name")
  );

  const orderid = require("order-id")("key");
  const id = orderid.generate();
  orderid.getTime(id);

  useEffect(() => {
    setOrderBasket(sessionStorage.getItem("basket"));

    const addToDb = async () => {
      setOrderId(id);
      let arrayToInsert;
      if (currentUser) {
        // 회원 주문
        arrayToInsert = {
          email: sessionStorage.getItem("checkout_email"),
          taxRate: sessionStorage.getItem("checkout_tax_rate"),
          basket: sessionStorage.getItem("basket"),
          checkout_taxprice: sessionStorage.getItem("checkout_taxprice"),
          shippingOption: sessionStorage.getItem("checkout_shippingOption"),
          shippingPrice: sessionStorage.getItem("checkout_shippingPrice"),
          finalPrice: sessionStorage.getItem("checkout_total"),
          subtotal: sessionStorage.getItem("checkout_subtotal"),
          user_uid: currentUser.uid,
          created: serverTimestamp(),
          status: ["Preparing for shipment"],
          address_firstname: sessionStorage.getItem(
            "checkout_shippingFirstname"
          ),
          address_lastname: sessionStorage.getItem("checkout_shippingLastname"),
          address_address: sessionStorage.getItem("checkout_shippingAddress"),
          address_apt: sessionStorage.getItem("checkout_shippingApt"),
          address_city: sessionStorage.getItem("checkout_shippingCity"),
          address_state: sessionStorage.getItem("checkout_shippingState"),
          address_zipcode: sessionStorage.getItem("checkout_shippingZipcode"),
          phone: sessionStorage.getItem("phone"),
          payment_status: {
            paymentOption: sessionStorage.getItem("paymentOption"),
            bank: sessionStorage.getItem("bank"),
            customer_name: sessionStorage.getItem("customer_name"),
          },
        };
      } else {
        // 비회원 주문
        arrayToInsert = {
          email: sessionStorage.getItem("checkout_email"),
          taxRate: sessionStorage.getItem("checkout_tax_rate"),
          basket: sessionStorage.getItem("basket"),
          checkout_taxprice: sessionStorage.getItem("checkout_taxprice"),
          shippingOption: sessionStorage.getItem("checkout_shippingOption"),
          shippingPrice: sessionStorage.getItem("checkout_shippingPrice"),
          finalPrice: sessionStorage.getItem("checkout_total"),
          subtotal: sessionStorage.getItem("checkout_subtotal"),

          created: serverTimestamp(),
          status: ["Preparing for shipment"],
          address_firstname: sessionStorage.getItem(
            "checkout_shippingFirstname"
          ),
          address_lastname: sessionStorage.getItem("checkout_shippingLastname"),
          address_address: sessionStorage.getItem("checkout_shippingAddress"),
          address_apt: sessionStorage.getItem("checkout_shippingApt"),
          address_city: sessionStorage.getItem("checkout_shippingCity"),
          address_state: sessionStorage.getItem("checkout_shippingState"),
          address_zipcode: sessionStorage.getItem("checkout_shippingZipcode"),
          guestPassword: sessionStorage.getItem("checkout_guestPassword"),
          phone: sessionStorage.getItem("phone"),
          payment_status: {
            paymentOption: sessionStorage.getItem("paymentOption"),
            bank: sessionStorage.getItem("bank"),
            customer_name: sessionStorage.getItem("customer_name"),
          },
        };
      }

      addToUser();

      await setDoc(doc(db, "KO_orders", id), arrayToInsert).then(
        async (res) => {
          if (currentUser?.uid) {
            // Send it to the customer
            var templateParams1 = {
              user_email: "rnwldms@gmail.com", // helset email
              reply_to: "rnwldms@gmail.com",
              order_id: id,
              checkout_shippingLastname: sessionStorage.getItem(
                "checkout_shippingLastname"
              ),
              checkout_shippingFirstname: sessionStorage.getItem(
                "checkout_shippingFirstname"
              ),

              checkout_shippingAddress: sessionStorage.getItem(
                "checkout_shippingAddress"
              ),
              checkout_shippingApt: sessionStorage.getItem(
                "checkout_shippingApt"
              ),

              checkout_shippingCity: sessionStorage.getItem(
                "checkout_shippingCity"
              ),

              checkout_shippingState: sessionStorage.getItem(
                "checkout_shippingState"
              ),

              checkout_shippingZipcode: sessionStorage.getItem(
                "checkout_shippingZipcode"
              ),
            };
            emailjs
              .send(
                "service_5xp50vc",
                "template_fakib8v",
                templateParams1,
                "user_7Zql27tiMF2NZkNx1LGdg"
              )
              .then(
                (result) => {
                  console.log(result.text);
                },
                (error) => {
                  console.log(error.text);
                }
              );

            // Send it to Heslet
            // var templateParams2 = {
            //   user_email: "rnwldms@gmail.com", // helset email
            //   reply_to: "rnwldms@gmail.com",
            // };
            // emailjs
            //   .send(
            //     "service_5xp50vc",
            //     "template_aroxsrj",
            //     templateParams2,
            //     "user_7Zql27tiMF2NZkNx1LGdg"
            //   )
            //   .then(
            //     (result) => {
            //       console.log(result.text);
            //       // setMsg((old) => t("Your message is sent. Thank you!"));
            //     },
            //     (error) => {
            //       console.log(error.text);
            //     }
            //   );

            const docRef2 = await addDoc(collection(db, "mail"), {
              orderNumber: id,
              to: "rnwldms@gmail.com",
              from: "rnwldms@gmail.com",
              message: {
                subject: "Heslet - Order Placed. Shipping Label is included.",
                html: `<!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <meta http-equiv="X-UA-Compatible" content="IE=edge">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Thank you!</title><style>
                        @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
                        .myDiv {
                            font-family: 'Roboto', sans-serif;
                          border: 1px solid lightgray;
                          width:400px;
                         margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
                         padding-left:20px; padding-right:20px; line-height: 1.8em;
                        }
                        .logo{display:flex;  justify-content: space-between;}
                        .confirm{top:+40px;position:relative}
                        .blue{color:#153a5a; font-weight: bold;}
                        .hello{padding-top:30px}
                        .detail{padding-top:30px;border-bottom:1px solid lightgray;}
                        .order{padding-top:20px}
                        .green{color:#689f38}
                        .custom_btn{background-color: #153a5b;
                  color: white;
                  letter-spacing: 3px;
                  border-radius: 0;
                  width: 100%;
                  border: none;
                  text-transform: uppercase;
                  padding-top: 15px;
                  padding-bottom: 15px;
                  cursor: pointer;}
                    .button{padding-top:20px}
                    .ship{padding-top:20px}
                    .Recommendations{padding-top:40px}
                    .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
                    .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
                    justify-content: space-evenly;}
                    /* .each{padding-left:3px; padding-right:3px;}   */
                      
                      </style>
                </head>
                <body>
                    <div class="myDiv">
                        <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
                        <div class="confirm" style="padding-left:20px;padding-top:20px;">Order Placed</div></div>
                        <br />
                   
                        <br />An order is place. Here is the order.
                    
                        <div class="detail blue">Details</div>
                        <div class="order">Order #: ${id}</div>
                        <div>Total Price: $${sessionStorage.getItem(
                          "checkout_total"
                        )}</div>
                        
                        <div class="green">
                            Arriving:
                Saturday, February 19 -
                Sunday, February 27
                        </div>
                        <div class="button"><button class="custom_btn">View Order</button></div>
                        <div class="ship">Ship To: </div>
                        <div>${
                          sessionStorage.getItem("checkout_shippingFirstname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingLastname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingAddress") +
                          " " +
                          sessionStorage.getItem("checkout_shippingApt") +
                          " " +
                          sessionStorage.getItem("checkout_shippingCity") +
                          " " +
                          sessionStorage.getItem("checkout_shippingState") +
                          " " +
                          sessionStorage.getItem("checkout_shippingZipcode")
                        }</div>
                
                
                        <div class="Recommendations">
                             Recommendations for items from across our store
                        </div>
                        <div class="recomm">
                       
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
                                <div>Premium Heavy Duty<br /> Hand Wipes</div>
                            </div>
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
                                <div>Premium<br /> All-Purpose Wipes</div>
                            </div>
                            <div class="each">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
                                <div>Premium <br />All Purpose Spray</div>
                            </div>
                        </div>
                        
                        <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
                    </div>
                 
                     
                </body>
                </html>`,
              },
            });

            const docRef = await addDoc(collection(db, "mail"), {
              orderNumber: id,
              to: sessionStorage.getItem("checkout_email"),
              from: "rnwldms@gmail.com",
              message: {
                subject: "Heslet - Order Placed",

                html: `<!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <meta http-equiv="X-UA-Compatible" content="IE=edge">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Thank you!</title><style>
                        @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
                        .myDiv {
                            font-family: 'Roboto', sans-serif;
                          border: 1px solid lightgray;
                          width:400px;
                         margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
                         padding-left:20px; padding-right:20px; line-height: 1.8em;
                        }
                        .logo{display:flex;  justify-content: space-between;}
                        .confirm{top:+40px;position:relative}
                        .blue{color:#153a5a; font-weight: bold;}
                        .hello{padding-top:30px}
                        .detail{padding-top:30px;border-bottom:1px solid lightgray;}
                        .order{padding-top:20px}
                        .green{color:#689f38}
                        .custom_btn{background-color: #153a5b;
                  color: white;
                  letter-spacing: 3px;
                  border-radius: 0;
                  width: 100%;
                  border: none;
                  text-transform: uppercase;
                  padding-top: 15px;
                  padding-bottom: 15px;
                  cursor: pointer;}
                    .button{padding-top:20px}
                    .ship{padding-top:20px}
                    .Recommendations{padding-top:40px}
                    .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
                    .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
                    justify-content: space-evenly;}
                    /* .each{padding-left:3px; padding-right:3px;}   */
                      
                      </style>
                </head>
                <body>
                    <div class="myDiv">
                        <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
                        <div class="confirm" style="padding-left:20px;padding-top:20px;">Order Placed</div></div>
                        <br />
                   
                        <br />Thank you for shopping with us. We'll send a confirmation when your item ships.
                    
                        <div class="detail blue">Details</div>
                        <div class="order">Order #: ${id}</div>
                        <div>Total Price: $${sessionStorage.getItem(
                          "checkout_total"
                        )}</div>
                        <div class="green">
                            Arriving:
                Saturday, February 19 -
                Sunday, February 27
                        </div>
                        <div class="button"><button class="custom_btn">View Order</button></div>
                        <div class="ship">Ship To: </div>
                        <div>${
                          sessionStorage.getItem("checkout_shippingFirstname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingLastname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingAddress") +
                          " " +
                          sessionStorage.getItem("checkout_shippingApt") +
                          " " +
                          sessionStorage.getItem("checkout_shippingCity") +
                          " " +
                          sessionStorage.getItem("checkout_shippingState") +
                          " " +
                          sessionStorage.getItem("checkout_shippingZipcode")
                        }</div>
                
                
                        <div class="Recommendations">
                             Recommendations for items from across our store
                        </div>
                        <div class="recomm">
                       
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
                                <div>Premium Heavy Duty<br /> Hand Wipes</div>
                            </div>
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
                                <div>Premium<br /> All-Purpose Wipes</div>
                            </div>
                            <div class="each">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
                                <div>Premium <br />All Purpose Spray</div>
                            </div>
                        </div>
                        
                        <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
                    </div>
                 
                     
                </body>
                </html>`,
              },
            });

            console.log("docRef", docRef);
          } else {
            //비회원
            console.log("비회원 비회원 비회원");

            const docRef2 = await addDoc(collection(db, "mail"), {
              orderNumber: id,
              to: "rnwldms@gmail.com",
              from: "rnwldms@gmail.com",
              message: {
                subject: "Heslet - Order Placed. Shipping Label is included.",
                html: `<!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <meta http-equiv="X-UA-Compatible" content="IE=edge">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Thank you!</title><style>
                        @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
                        .myDiv {
                            font-family: 'Roboto', sans-serif;
                          border: 1px solid lightgray;
                          width:400px;
                         margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
                         padding-left:20px; padding-right:20px; line-height: 1.8em;
                        }
                        .logo{display:flex;  justify-content: space-between;}
                        .confirm{top:+40px;position:relative}
                        .blue{color:#153a5a; font-weight: bold;}
                        .hello{padding-top:30px}
                        .detail{padding-top:30px;border-bottom:1px solid lightgray;}
                        .order{padding-top:20px}
                        .green{color:#689f38}
                        .custom_btn{background-color: #153a5b;
                  color: white;
                  letter-spacing: 3px;
                  border-radius: 0;
                  width: 100%;
                  border: none;
                  text-transform: uppercase;
                  padding-top: 15px;
                  padding-bottom: 15px;
                  cursor: pointer;}
                    .button{padding-top:20px}
                    .ship{padding-top:20px}
                    .Recommendations{padding-top:40px}
                    .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
                    .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
                    justify-content: space-evenly;}
                    /* .each{padding-left:3px; padding-right:3px;}   */
                      
                      </style>
                </head>
                <body>
                    <div class="myDiv">
                        <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
                        <div class="confirm" style="padding-left:20px;padding-top:20px;">Order Placed</div></div>
                        <br />
                   
                        <br />An order is place. Here is the order.
                    
                        <div class="detail blue">Details</div>
                        <div class="order">Order #: ${id}</div>
                        <div>Total Price: $${sessionStorage.getItem(
                          "checkout_total"
                        )}</div>
                        
                        <div class="green">
                            Arriving:
                Saturday, February 19 -
                Sunday, February 27
                        </div>
                        <div class="button"><button class="custom_btn">View Order</button></div>
                        <div class="ship">Ship To: </div>
                        <div>${
                          sessionStorage.getItem("checkout_shippingFirstname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingLastname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingAddress") +
                          " " +
                          sessionStorage.getItem("checkout_shippingApt") +
                          " " +
                          sessionStorage.getItem("checkout_shippingCity") +
                          " " +
                          sessionStorage.getItem("checkout_shippingState") +
                          " " +
                          sessionStorage.getItem("checkout_shippingZipcode")
                        }</div>
                
                
                        <div class="Recommendations">
                             Recommendations for items from across our store
                        </div>
                        <div class="recomm">
                       
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
                                <div>Premium Heavy Duty<br /> Hand Wipes</div>
                            </div>
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
                                <div>Premium<br /> All-Purpose Wipes</div>
                            </div>
                            <div class="each">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
                                <div>Premium <br />All Purpose Spray</div>
                            </div>
                        </div>
                        
                        <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
                    </div>
                 
                     
                </body>
                </html>`,
              },
            });

            const docRef = await addDoc(collection(db, "mail"), {
              orderNumber: id,
              to: sessionStorage.getItem("checkout_email"),
              from: "rnwldms@gmail.com",
              message: {
                subject: "Heslet - Order Placed",

                html: `<!DOCTYPE html>
                <html lang="en">
                <head>
                    <meta charset="UTF-8">
                    <meta http-equiv="X-UA-Compatible" content="IE=edge">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Thank you!</title><style>
                        @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
                        .myDiv {
                            font-family: 'Roboto', sans-serif;
                          border: 1px solid lightgray;
                          width:400px;
                         margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
                         padding-left:20px; padding-right:20px; line-height: 1.8em;
                        }
                        .logo{display:flex;  justify-content: space-between;}
                        .confirm{top:+40px;position:relative}
                        .blue{color:#153a5a; font-weight: bold;}
                        .hello{padding-top:30px}
                        .detail{padding-top:30px;border-bottom:1px solid lightgray;}
                        .order{padding-top:20px}
                        .green{color:#689f38}
                        .custom_btn{background-color: #153a5b;
                  color: white;
                  letter-spacing: 3px;
                  border-radius: 0;
                  width: 100%;
                  border: none;
                  text-transform: uppercase;
                  padding-top: 15px;
                  padding-bottom: 15px;
                  cursor: pointer;}
                    .button{padding-top:20px}
                    .ship{padding-top:20px}
                    .Recommendations{padding-top:40px}
                    .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
                    .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
                    justify-content: space-evenly;}
                    /* .each{padding-left:3px; padding-right:3px;}   */
                      
                      </style>
                </head>
                <body>
                    <div class="myDiv">
                        <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
                        <div class="confirm" style="padding-left:20px;padding-top:20px;">Order Placed</div></div>
                        <br />
                   
                        <br />Thank you for shopping with us. We'll send a confirmation when your item ships.
                    
                        <div class="detail blue">Details</div>
                        <div class="order">Order #: ${id}</div>
                        <div>Total Price: $${sessionStorage.getItem(
                          "checkout_total"
                        )}</div>
                        <div class="green">
                            Arriving:
                Saturday, February 19 -
                Sunday, February 27
                        </div>
                        <div class="button"><button class="custom_btn">View Order</button></div>
                        <div class="ship">Ship To: </div>
                        <div>${
                          sessionStorage.getItem("checkout_shippingFirstname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingLastname") +
                          " " +
                          sessionStorage.getItem("checkout_shippingAddress") +
                          " " +
                          sessionStorage.getItem("checkout_shippingApt") +
                          " " +
                          sessionStorage.getItem("checkout_shippingCity") +
                          " " +
                          sessionStorage.getItem("checkout_shippingState") +
                          " " +
                          sessionStorage.getItem("checkout_shippingZipcode")
                        }</div>
                
                
                        <div class="Recommendations">
                             Recommendations for items from across our store
                        </div>
                        <div class="recomm">
                       
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
                                <div>Premium Heavy Duty<br /> Hand Wipes</div>
                            </div>
                            <div class="each" style="padding-right:30px;">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
                                <div>Premium<br /> All-Purpose Wipes</div>
                            </div>
                            <div class="each">
                                <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
                                <div>Premium <br />All Purpose Spray</div>
                            </div>
                        </div>
                        
                        <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
                    </div>
                 
                     
                </body>
                </html>`,
              },
            });

            let basket = JSON.parse(sessionStorage.getItem("basket"));

            basket.map(async (item) => {
              const ref = doc(db, "KO_products", item.id);
              const docSnap = await getDoc(ref);
              if (docSnap.exists()) {
                console.log("Document data:", docSnap.data());
                let quantity = docSnap.data().quantity;
                let newQuantity = quantity - item.quantity;

                setDoc(ref, { quantity: newQuantity }, { merge: true });
              }
            });
            removeAll();
          }
        }
      );
      removeAll();
    };

    if (sessionStorage.getItem("FinishCheckoutKorea")) {
      addToDb();
    }

    return () => {
      removeAll();
    };
  }, []);
  const removeAll = () => {
    sessionStorage.removeItem("checkout_email");
    sessionStorage.removeItem("checkout_tax_rate");
    sessionStorage.removeItem("checkout_shippingOption");
    sessionStorage.removeItem("checkout_shippingPrice");
    sessionStorage.removeItem("checkout_total");
    sessionStorage.removeItem("getSubtotal");
    sessionStorage.removeItem("checkout_subtotal");
    sessionStorage.removeItem("checkout_guestPassword");
    sessionStorage.removeItem("FinishCheckoutKorea");
    emptyBasket();
  };

  const addToUser = async () => {
    let basket = JSON.parse(sessionStorage.getItem("basket"));

    basket.map(async (item) => {
      const ref = doc(db, "products", item.id);
      const docSnap = await getDoc(ref);
      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        let quantity = docSnap.data().quantity;
        let newQuantity = quantity - item.quantity;

        setDoc(ref, { quantity: newQuantity }, { merge: true });
      }
    });

    // const proRef = doc(db, "products", currentUser.uid);

    const docRef = doc(db, "users", currentUser.uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      console.log("Basket data:", basket);

      if (docSnap.data().purchases) {
        console.log("purchase found");
        let purchases = docSnap.data().purchases;
        basket.map((item) => {
          // if (docSnap.data().purchases.indexOf(item.id) < 0) {
          purchases.push(item.id);
          // }
        });
        await setDoc(docRef, { purchases: purchases }, { merge: true });
      } else {
        let purchases = [];
        basket?.map((item) => {
          console.log("item.id", item.id);
          purchases.push(item.id);
        });
        await setDoc(docRef, { purchases: purchases }, { merge: true });
      }
    }
    removeAll();
  };

  // if (!orderId) {
  //   navigate("/");
  // }
  return (
    <Box
      sx={{
        py: 10,
        pt: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Fade delay="300">
        <h1>
          <CheckCircleOutlineIcon sx={{ fontSize: "70px", color: "#a2cf6e" }} />
        </h1>
        <Box sx={{ fontSize: "18px", fontWeight: 600 }}>{t("Thank you")}</Box>
        <Box
          sx={{
            pt: 4,
            fontSize: "15px",
            textAlign: "center",
            lineHeight: "160%",
          }}
        >
          <Box sx={{}}> {orderId ? t("Order #: ") + orderId : null}</Box>
          {t("Your order was completed successfully.")}
          <br />
          <br />
          <div
            className="normal"
            dangerouslySetInnerHTML={{
              __html: t(
                "You will receive an order confirmation email shortly."
              ),
            }}
          />
        </Box>

        <Box
          sx={{
            pt: 5,
            display: "flex",
          }}
        ></Box>

        <Box sx={{ width: "400px" }}>
          <HashLink to="/products-cleansing">
            <button className="custom_btn">{t("Continue Shopping")}</button>
          </HashLink>
          <HashLink to="/dashboard">
            {currentUser && (
              <button
                className="custom_btn_whitebg"
                style={{ marginTop: "20px" }}
              >
                {t("Order History")}
              </button>
            )}
          </HashLink>
        </Box>
      </Fade>
      <Box sx={{ pt: 10 }}></Box>
      <FeaturedProductRecent width={7} />
    </Box>
  );
};

export default Success;
